var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-custom-progress",style:({ width : _vm.width,backgroundColor : _vm.bgColor })})
}
var staticRenderFns = []

export { render, staticRenderFns }